import { render } from "./MasterDataPermissionView.vue?vue&type=template&id=b3d70dd0&scoped=true&ts=true"
import script from "./MasterDataPermissionView.vue?vue&type=script&lang=ts"
export * from "./MasterDataPermissionView.vue?vue&type=script&lang=ts"

import "./MasterDataPermissionView.vue?vue&type=style&index=0&id=b3d70dd0&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3d70dd0"]])

export default __exports__